<script setup>
import {ref, onBeforeMount, onMounted} from 'vue'
import simpleQuiz from '../data/simple.json'
import {useNetworkStore} from "../stores/network";

const network = useNetworkStore()

const INTRO = 'intro'
const QUESTION = 'question'
const FEEDBACK = 'feedback'
const RESULT = 'result'

const currentStep = ref(INTRO)

const questions = {}
const questionIndex = ref(1)
const totalQuestions = Object.keys(simpleQuiz).length

const positiveFeedback = ref(false)

const points = ref(0)
const feedbackTxt = ref('')

const scoreMessages = {
  high: "SUPER! Vous connaissez tous les trucs et astuces pour gérer la climatisation de votre maison de façon intelligente!",
  mid: "Bravo! Vous êtes en bonne voie! Comblez vos lacunes et vous serez un champion de l'éco-geste",
  low: "Améliorez-vous! Revoyez tous les éco-gestes pour une meilleure climatisation!  Vous ferez des économies d'énergie!"
}

const getScoreMessage = () => {
  if (points.value >= 6) {
    return scoreMessages.high
  } else if (points.value >= 4) {
    return scoreMessages.mid
  } else {
    return scoreMessages.low
  }
}

const scoreMessage = ref('')

//todo record already taken questions
onBeforeMount(() => {
  pickRandomQuestionFromTheme()
})

onMounted(() => {
  network.sendStartGame({type:'simple'})
})

const pickRandomQuestionFromTheme = () => {
  Object.keys(simpleQuiz).forEach((theme) => {
    const randomIndex = Math.floor(Math.random() * simpleQuiz[theme]['items'].length)
    const question = simpleQuiz[theme]['items'][randomIndex]
    if (Math.random() > 0.5) {
      const tmp = question.choices[0]
      question.choices[0] = question.choices[1]
      question.choices[1] = tmp
    }

    questions[theme] = question
  })
}

const answerPicked = (choice) => {
  points.value += parseInt(choice.points)

  if (points.value < 0) {
    points.value = 0
  }

  const positive = choice.points > 0

  displayFeedback(true, positive, questions[questionIndex.value].feedback)

  network.sendAnswer({
    question: questions[questionIndex.value].id,
    answer: choice.points,
  })
}

const showNextQuestion = () => {
  if (questionIndex.value === totalQuestions) {
    console.log('end of quiz')
    displayResult()
    return
  }

  questionIndex.value += 1
  displayFeedback(false)
}

const displayFeedback = (display, positive = false, feedback = '') => {
  if (display) {
    feedbackTxt.value = feedback
    currentStep.value = FEEDBACK
  } else {
    currentStep.value = QUESTION
  }
  positiveFeedback.value = positive
}

const displayResult = () => {
  scoreMessage.value = getScoreMessage()
  currentStep.value = RESULT
}

const restartQuiz = () => {
  currentStep.value = INTRO
  questionIndex.value = 1
  points.value = 0
  pickRandomQuestionFromTheme()
}
</script>

<template>
  <div class="simple-page">
    <div class="simple-container">
      <Transition name="fade">
        <div class="intro-container" v-if="currentStep === INTRO">
          <div class="question-count">
            <img src="/static/vendors/images/logo.png" alt="">
            <h1>Idées Fraîches</h1>
            <h2>Les écogestes pour une meilleure climatisation</h2>
            <div class="wave">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #0087b1;"></path>
              </svg>
            </div>
          </div>
          <div class="intro-content">
            <p>
              <strong>Idées Fraîches</strong> est un jeu de quiz qui vous permettra de tester vos connaissances sur les
              éco-gestes pour une meilleure climatisation de votre maison.
            </p>
            <div class="intro-button" @click="currentStep = QUESTION">Faire le quiz</div>
            <img class="cee-logo" src="/static/vendors/images/CEE.png" alt="Les certificats d'économie énergétique">
          </div>

        </div>
        <div class="question-container" v-else-if="currentStep === QUESTION">
          <div class="question-count">
            <p>Question {{ questionIndex }}</p>
            <!-- Generated by https://smooth.ie/blogs/news/svg-wavey-transitions-between-sections -->

            <div class="wave">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #fff;"></path>
              </svg>
            </div>
          </div>

          <div class="question-text">

            <p v-html="questions[questionIndex].text"></p>
          </div>
          <div class="question-choices">
            <div v-for="choice in questions[questionIndex].choices"
                 :key="choice.id"
                 class="question-choice"
                 @click="answerPicked(choice)"
                 v-html="choice.text">

            </div>
          </div>
          <!-- Generated by https://smooth.ie/blogs/news/svg-wavey-transitions-between-sections -->


          <div class="question-footer">
            <div class="wave-footer">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #0bacda;"></path>
              </svg>
            </div>
            {{ questionIndex }} / {{ totalQuestions }}
          </div>
        </div>
        <div class="feedback-container" v-else-if="currentStep === FEEDBACK">
          <div class="question-count">
            <p>Question {{ questionIndex }}</p>
            <div class="wave">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #0087b1;"></path>
              </svg>
            </div>
          </div>
          <div class="feedback-text">
            <div class="feedback-button feedback-positive" v-if="positiveFeedback">Bonne réponse</div>
            <div class="feedback-button feedback-negative" v-else>Mauvaise réponse</div>
            <p v-html="feedbackTxt"></p>
            <img src="~../assets/next.png" @click="showNextQuestion" alt="Suivant">
          </div>
          <div class="question-footer">
            <div class="wave-footer">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #0bacda;"></path>
              </svg>
            </div>
            {{ questionIndex }} / {{ totalQuestions }}
          </div>
        </div>
        <div class="results-container" v-else-if="currentStep === RESULT">
          <div class="question-count">
            <img src="/static/vendors/images/logo.png" alt="">
            <h1>Bien joué</h1>
            <div class="wave">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
                <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #0087b1;"></path>
              </svg>
            </div>
          </div>
          <div class="results-content">
            <div class="score-badge">{{ points }}/8</div>
            <p v-html="scoreMessage"></p>
            <div class="btn-container">
              <div class="intro-button" @click="restartQuiz">Nouvelle partie</div>
              <a class="intro-button" href="/">Quitter</a>
            </div>
          </div>
        </div>
      </Transition>
      <!--      <p>Points: {{ points }}</p>-->
    </div>
  </div>
</template>

<style lang="scss" scoped>


@font-face {
  font-family: 'LeagueGothic';
  src: url('~../assets/LeagueGothic-Regular.ttf') format('truetype');
}

.wave {
  height: 40px;
  overflow: hidden;
  background-color: #f3f3f3;
}

.cee-logo {
  max-height: 60px;
  margin-top: 1.5rem;
}

.score-badge {
  width: 180px;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #0bacda;
  color: #fff;
  font-size: 5rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 2rem;

  margin-top: 0;
  margin-bottom: 3rem;
  border-radius: 50%;

}

.intro-container, .results-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  height: 100%;

  h1 {
    margin: 0;
    font-size: 5rem;
  }

  h2 {
    margin: 0 100px;
    font-size: 1.5rem;
    font-weight: normal;
    color: #0bacda;
  }

  .intro-content, .results-content {

    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    flex-grow: 1;
    background-color: #0087b1;
    color: white;

    font-size: 1.2rem;

    .intro-button {
      margin-top: 1rem;

      padding: 1rem 0;
      border-radius: 1.5rem;
      color: white;
      font-size: 1.5rem;
      text-transform: uppercase;
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      background-color: #0bacda;
      cursor: pointer;
    }
  }

  .results-content {
    font-size: 1.8rem;
    line-height: 2rem;
    padding: 30px 10%;

    .btn-container {
      width: 100%;
    }

    a {
      text-decoration: none;
    }
  }
}

.feedback-text {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  background-color: #0087b1;
  color: white;

  font-size: 1.5rem;

  img {
    width: 100px;
    height: 100px;
    cursor: pointer;
  }
}

.feedback-button {
  margin-top: 3rem;
  padding: 2rem 0;
  border-radius: 1.5rem;
  border: none;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  &.feedback-positive {
    background-color: #3aa934;
  }

  &.feedback-negative {
    background-color: #c80000;
  }
}

.question-count {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1e95ba;
  background-color: #f3f3f3;
  padding: 1.5rem 0 0 0;

  text-transform: uppercase;

  p {
    margin: 0;
  }
}

.question-container, .feedback-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  height: 100%;

  text-align: center;


  .question-text {
    background-color: #fff;
    color: #00aadb;
    height: 25%;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;

    font-size: 1.8rem;
    line-height: 2rem;
    //font-weight: bold;
  }

  .question-choices {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    background-color: #0087b1;

    .question-choice {
      height: 80px;
      margin: .5rem;
      border-radius: 2.5rem;
      border: none;
      background-color: #fff;
      color: #6f6f6f;
      font-size: 1.8rem;
      width: 80%;

      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;

      &:hover {
        background-color: #f3f3f3;
      }
    }
  }

  .question-footer {
    font-size: 1.2rem;
    //font-weight: bold;
    background-color: #0bacda;
    color: white;
    padding: 0 0 .5rem 0;
  }

  .wave-footer {
    margin-bottom: -1px;
    height: 40px;
    overflow: hidden;
    background-color: #0087b1;
  }
}

.simple-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  background-image: url("~../assets/quiz-bg2.jpg");
  background-size: cover;
  background-position: right;
  font-family: 'LeagueGothic', sans-serif;

  .simple-container {
    max-width: 480px;
    width: 100%;
    max-height: 800px;
    height: 100%;
    flex-grow: 1;

    background-color: white;
    position: relative;

    & > div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s linear;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(150px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-150px);
}
</style>